var _path, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-121",
    d: "M102.57,450.16C27.86,407,27.86,337.1,102.57,294s195.83-43.13,270.53,0,74.71,113.06,0,156.19S177.28,493.29,102.57,450.16Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-121"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-121",
    points: "276.18 403.22 280.49 405.71 138.88 427.74 138.88 424.58 276.18 403.22",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-121",
    d: "M90.26,441c-9.64,5.63-9.64,14.75,0,20.38s25.27,5.63,34.92,0,9.64-14.75,0-20.38S99.9,435.33,90.26,441Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-121",
    d: "M237.65,359c-23.32,13.62-23.32,35.69,0,49.3s61.12,13.61,84.43,0,23.31-35.68,0-49.3S261,345.43,237.65,359Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-121",
    d: "M337.25,361.42c6.64-.58,14-1,19.25,3.1,2.47,1.91,4.18,4.6,6.06,7.09a57.82,57.82,0,0,0,6.72,7.44,16.36,16.36,0,0,0,4.27,3.08,13.33,13.33,0,0,0,5.59,1c8,0,15.43-4.42,21.59-9.58,1.65-1.38,3.33-3,3.76-5.08.72-3.47-2.21-6.62-5.2-8.52-8.42-5.36-18.9-8.44-28.48-11a113.62,113.62,0,0,0-31.38-4.23,90.51,90.51,0,0,0-19.59,2.53c-3.88.94-9.5,2.1-12.5,4.93a4.68,4.68,0,0,0-1.47,4.86c.75,2,3.05,2.79,5.11,3.27C319.52,362.33,328.6,362.17,337.25,361.42Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.7,169v3.82c0,1.21.85,1.7,1.89,1.09l3.69-2.13v-8.19l-3.69,2.13A4.2,4.2,0,0,0,117.7,169Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,294.35l-15.4,8.9a4.16,4.16,0,0,0-1.89,3.27v3.83c0,1.2.84,1.69,1.89,1.09l15.4-8.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,165.71v3.83c0,1.2.84,1.69,1.89,1.09l15.4-8.9v-8.19l-15.4,8.9A4.16,4.16,0,0,0,106,165.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.32,209l-17.5,10.11a4.19,4.19,0,0,0-1.89,3.27v3.83c0,1.2.85,1.69,1.89,1.09l17.5-10.1a4.18,4.18,0,0,0,1.89-3.28v-3.82C116.21,208.84,115.37,208.35,114.32,209Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,254.12l-15.4,8.9a4.16,4.16,0,0,0-1.89,3.27v3.83c0,1.2.84,1.69,1.89,1.09l15.4-8.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,125.48v3.82c0,1.21.84,1.7,1.89,1.1l15.4-8.9v-8.19l-15.4,8.9A4.14,4.14,0,0,0,106,125.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,354.7l-15.4,8.9a4.16,4.16,0,0,0-1.89,3.27v3.83c0,1.2.84,1.69,1.89,1.09l15.4-8.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.46,246.42v3.82c0,1.21.84,1.7,1.89,1.09l17.49-10.1a4.17,4.17,0,0,0,1.9-3.27v-3.83c0-1.2-.85-1.69-1.9-1.09l-17.49,10.1A4.18,4.18,0,0,0,88.46,246.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,205.94v3.83c0,1.2.84,1.69,1.89,1.09l15.4-8.89v-8.2l-15.4,8.9A4.16,4.16,0,0,0,106,205.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,271v-3.82c0-1.21-.85-1.7-1.89-1.09l-17.5,10.1a4.19,4.19,0,0,0-1.89,3.27v3.83c0,1.2.85,1.69,1.89,1.09l17.5-10.1A4.2,4.2,0,0,0,104.5,271Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,368.06l17.5-10.1a4.18,4.18,0,0,0,1.89-3.28v-3.82c0-1.21-.84-1.7-1.89-1.09l-17.5,10.1a4.19,4.19,0,0,0-1.89,3.27V367C94.93,368.17,95.78,368.66,96.82,368.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.59,114.14l-17.5,10.1a4.16,4.16,0,0,0-1.89,3.27v3.83c0,1.2.84,1.69,1.89,1.09l17.5-10.1a4.2,4.2,0,0,0,1.89-3.28v-3.82C106.48,114,105.63,113.53,104.59,114.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.32,128.49l-17.5,10.1a4.2,4.2,0,0,0-1.89,3.28v3.82c0,1.21.85,1.7,1.89,1.09l17.5-10.1a4.16,4.16,0,0,0,1.89-3.27v-3.83C116.21,128.38,115.37,127.89,114.32,128.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.32,168.72l-17.5,10.11a4.17,4.17,0,0,0-1.89,3.27v3.83c0,1.2.85,1.69,1.89,1.09l17.5-10.11a4.16,4.16,0,0,0,1.89-3.27v-3.83C116.21,168.61,115.37,168.12,114.32,168.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,287.6l17.5-10.11a4.14,4.14,0,0,0,1.89-3.27v-3.83c0-1.2-.84-1.69-1.89-1.09l-17.5,10.11a4.17,4.17,0,0,0-1.89,3.27v3.83C94.93,287.71,95.78,288.2,96.82,287.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,314.47l-15.4,8.9a4.14,4.14,0,0,0-1.89,3.27v3.82c0,1.21.84,1.7,1.89,1.1l15.4-8.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,83.88V87.7A4.19,4.19,0,0,1,284.86,91l-3.69,2.13V84.92l3.69-2.13C285.9,82.19,286.75,82.67,286.75,83.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.17,215.7l15.41-8.89c1-.61,1.89-.12,1.89,1.09v3.82a4.2,4.2,0,0,1-1.89,3.28l-15.41,8.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.47,67.09v3.82a4.2,4.2,0,0,1-1.89,3.28l-15.41,8.89V74.89L296.58,66C297.62,65.39,298.47,65.88,298.47,67.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,120l17.5-10.11c1-.6,1.89-.11,1.89,1.09v3.83a4.17,4.17,0,0,1-1.89,3.27l-17.5,10.11c-1.05.6-1.89.11-1.89-1.09v-3.83A4.16,4.16,0,0,1,290.13,120Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.17,175.47l15.41-8.89c1-.61,1.89-.12,1.89,1.09v3.82a4.2,4.2,0,0,1-1.89,3.28l-15.41,8.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.47,26.85v3.83A4.17,4.17,0,0,1,296.58,34l-15.41,8.9V34.66l15.41-8.9C297.62,25.16,298.47,25.65,298.47,26.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.17,276.05l15.41-8.89c1-.61,1.89-.12,1.89,1.09v3.82a4.2,4.2,0,0,1-1.89,3.28l-15.41,8.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,127.55v3.83a4.19,4.19,0,0,1-1.89,3.27l-17.5,10.1c-1.05.61-1.89.12-1.89-1.09v-3.82a4.18,4.18,0,0,1,1.89-3.28l17.5-10.1C315.15,125.86,316,126.35,316,127.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.47,107.32v3.82a4.19,4.19,0,0,1-1.89,3.28l-15.41,8.89v-8.19l15.41-8.89C297.62,105.62,298.47,106.11,298.47,107.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,170.61v-3.82a4.19,4.19,0,0,1,1.89-3.28l17.5-10.1c1.05-.6,1.89-.12,1.89,1.09v3.83a4.16,4.16,0,0,1-1.89,3.27l-17.5,10.1C300.8,172.31,300,171.82,300,170.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,258.86,290.13,269c-1.05.6-1.89.11-1.89-1.09V264a4.16,4.16,0,0,1,1.89-3.27l17.5-10.1c1-.61,1.89-.12,1.89,1.09v3.82A4.2,4.2,0,0,1,307.63,258.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,39.49l17.5-10.1c1-.6,1.89-.11,1.89,1.09v3.83a4.19,4.19,0,0,1-1.89,3.27l-17.5,10.1c-1.05.61-1.89.12-1.89-1.09V42.77A4.18,4.18,0,0,1,290.13,39.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,79.72l17.5-10.1c1-.6,1.89-.11,1.89,1.09v3.83a4.19,4.19,0,0,1-1.89,3.27l-17.5,10.11c-1.05.6-1.89.11-1.89-1.1V83A4.18,4.18,0,0,1,290.13,79.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.63,178.39l-17.5,10.11c-1.05.6-1.89.11-1.89-1.1v-3.82a4.18,4.18,0,0,1,1.89-3.28l17.5-10.1c1-.6,1.89-.11,1.89,1.09v3.83A4.19,4.19,0,0,1,307.63,178.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.17,235.82l15.41-8.9c1-.6,1.89-.11,1.89,1.09v3.83a4.19,4.19,0,0,1-1.89,3.27L281.17,244Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Interior--inject-121"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.88 277.56 265.12 350.48 265.12 45.36 138.88 118.29 138.88 277.56",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.88 277.56 265.12 350.48 265.12 45.36 138.88 118.29 138.88 277.56",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.12 350.48 138.88 277.56 138.88 423.34 265.12 350.48",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Casing--inject-121"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "265.12 350.48 271.02 353.87 271.02 41.95 265.12 45.36 265.12 350.48",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.12 350.48 271.02 353.87 271.02 41.95 265.12 45.36 265.12 350.48",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.12 350.48 271.02 353.87 271.02 41.95 265.12 45.36 265.12 350.48",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.02 353.87 281.17 348.01 281.17 20.55 129.09 108.35 129.1 435.81 138.88 430.16 138.88 118.29 271.02 41.95 271.02 353.87",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.02 353.87 281.17 348.01 281.17 20.55 129.09 108.35 129.1 435.81 138.88 430.16 138.88 118.29 271.02 41.95 271.02 353.87",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.17 20.55 129.09 108.35 123.28 104.97 275.36 17.18 281.17 20.55",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.17 20.55 129.09 108.35 123.28 104.97 275.36 17.18 281.17 20.55",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.09 435.81 129.09 108.35 123.28 104.97 123.19 432.4 129.09 435.81",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "123.28 104.97 123.19 432.4 129.09 435.81 129.09 108.35",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.35,89a11.72,11.72,0,0,1,3.35.19,9,9,0,0,1,3,1.16,7.08,7.08,0,0,1,2.19,2.1,7,7,0,0,1,.78,5.61,7.56,7.56,0,0,1-1,2,12.69,12.69,0,0,1-1.4,1.69l-1.46,1.46a10.46,10.46,0,0,0-1.2,1.43,3,3,0,0,0-.54,1.54,1.5,1.5,0,0,1-.27.71.8.8,0,0,1-.62.34l-2.75.23a1,1,0,0,1-.73-.23.82.82,0,0,1-.33-.66,6.32,6.32,0,0,1,.39-2.53,8.77,8.77,0,0,1,1.11-2,12.94,12.94,0,0,1,1.46-1.66c.53-.51,1-1,1.46-1.45a8.06,8.06,0,0,0,1.09-1.37,2.27,2.27,0,0,0,.35-1.43,2.73,2.73,0,0,0-1.34-2.16,5,5,0,0,0-3.15-.63,4.75,4.75,0,0,0-4.25,3.45,2.29,2.29,0,0,1-.33.63,1,1,0,0,1-.66.25l-2.92.24a.76.76,0,0,1-.58-.17.73.73,0,0,1-.28-.55,5.56,5.56,0,0,1,.56-2.65A8.88,8.88,0,0,1,331,91.93a10.69,10.69,0,0,1,2.78-2A9.32,9.32,0,0,1,337.35,89Zm3.16,20.39a1,1,0,0,1,.71.24.9.9,0,0,1,.34.66l.27,3.18a1,1,0,0,1-.23.71.93.93,0,0,1-.67.34l-3.1.26a.93.93,0,0,1-.71-.23.94.94,0,0,1-.35-.66l-.26-3.18a.89.89,0,0,1,.23-.71.91.91,0,0,1,.66-.35Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.75,123.49a9,9,0,0,1,2.41,1.07,7,7,0,0,1,1.87,1.66,5.63,5.63,0,0,1,1,2.16,4.87,4.87,0,0,1-.1,2.53,4.94,4.94,0,0,1-.88,1.81,6.08,6.08,0,0,1-1.28,1.21,10.13,10.13,0,0,1-1.5.85l-1.48.68a7.77,7.77,0,0,0-1.27.72,2.26,2.26,0,0,0-.82,1,1.17,1.17,0,0,1-.4.45.63.63,0,0,1-.55.08l-2.09-.59a.72.72,0,0,1-.47-.37.64.64,0,0,1-.06-.57,5,5,0,0,1,1-1.75,7.27,7.27,0,0,1,1.37-1.19,9.93,9.93,0,0,1,1.54-.82c.53-.23,1-.45,1.47-.67a6.23,6.23,0,0,0,1.18-.7,1.8,1.8,0,0,0,.65-1,2.13,2.13,0,0,0-.39-2,3.93,3.93,0,0,0-2.14-1.33,3.74,3.74,0,0,0-4.09,1.37,1.66,1.66,0,0,1-.41.37.78.78,0,0,1-.55,0l-2.22-.63a.61.61,0,0,1-.38-.28.6.6,0,0,1-.06-.49,4.42,4.42,0,0,1,1.14-1.8,7.09,7.09,0,0,1,2-1.38,8.59,8.59,0,0,1,2.6-.71A7.59,7.59,0,0,1,359.75,123.49Zm-3.29,15.89a.75.75,0,0,1,.46.36.76.76,0,0,1,.07.59l-.68,2.41a.75.75,0,0,1-.36.46.77.77,0,0,1-.59.07l-2.36-.66a.72.72,0,0,1-.45-.37.74.74,0,0,1-.08-.58l.68-2.42a.77.77,0,0,1,.37-.46.74.74,0,0,1,.58-.07Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.75,123.49a9,9,0,0,1,2.41,1.07,7,7,0,0,1,1.87,1.66,5.63,5.63,0,0,1,1,2.16,4.87,4.87,0,0,1-.1,2.53,4.94,4.94,0,0,1-.88,1.81,6.08,6.08,0,0,1-1.28,1.21,10.13,10.13,0,0,1-1.5.85l-1.48.68a7.77,7.77,0,0,0-1.27.72,2.26,2.26,0,0,0-.82,1,1.17,1.17,0,0,1-.4.45.63.63,0,0,1-.55.08l-2.09-.59a.72.72,0,0,1-.47-.37.64.64,0,0,1-.06-.57,5,5,0,0,1,1-1.75,7.27,7.27,0,0,1,1.37-1.19,9.93,9.93,0,0,1,1.54-.82c.53-.23,1-.45,1.47-.67a6.23,6.23,0,0,0,1.18-.7,1.8,1.8,0,0,0,.65-1,2.13,2.13,0,0,0-.39-2,3.93,3.93,0,0,0-2.14-1.33,3.74,3.74,0,0,0-4.09,1.37,1.66,1.66,0,0,1-.41.37.78.78,0,0,1-.55,0l-2.22-.63a.61.61,0,0,1-.38-.28.6.6,0,0,1-.06-.49,4.42,4.42,0,0,1,1.14-1.8,7.09,7.09,0,0,1,2-1.38,8.59,8.59,0,0,1,2.6-.71A7.59,7.59,0,0,1,359.75,123.49Zm-3.29,15.89a.75.75,0,0,1,.46.36.76.76,0,0,1,.07.59l-.68,2.41a.75.75,0,0,1-.36.46.77.77,0,0,1-.59.07l-2.36-.66a.72.72,0,0,1-.45-.37.74.74,0,0,1-.08-.58l.68-2.42a.77.77,0,0,1,.37-.46.74.74,0,0,1,.58-.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M370.58,112.1a.71.71,0,0,1,.32.48.73.73,0,0,1-.11.56l-1.37,2a.71.71,0,0,1-.48.32.74.74,0,0,1-.56-.11l-2-1.34a.7.7,0,0,1-.31-.48.74.74,0,0,1,.11-.56l1.37-2a.76.76,0,0,1,1-.2Zm7.9-13.69a9.16,9.16,0,0,1,1.9,1.72,6.85,6.85,0,0,1,1.22,2.11,5.35,5.35,0,0,1,.3,2.31,4.82,4.82,0,0,1-.86,2.32,5.11,5.11,0,0,1-1.36,1.41,6.1,6.1,0,0,1-1.56.72,9.45,9.45,0,0,1-1.65.33l-1.57.17a7.54,7.54,0,0,0-1.4.29,2.3,2.3,0,0,0-1.06.65,1,1,0,0,1-.5.3.62.62,0,0,1-.54-.1l-1.75-1.18a.74.74,0,0,1-.32-.48.62.62,0,0,1,.12-.56,5.21,5.21,0,0,1,1.44-1.32,6.92,6.92,0,0,1,1.63-.67,9.94,9.94,0,0,1,1.67-.3c.56,0,1.08-.1,1.57-.16a6.41,6.41,0,0,0,1.3-.29,1.83,1.83,0,0,0,.9-.69,2.09,2.09,0,0,0,.23-1.93,3.8,3.8,0,0,0-1.57-1.89,3.67,3.67,0,0,0-4.2,0,1.55,1.55,0,0,1-.49.22.78.78,0,0,1-.52-.16L369.55,100a.57.57,0,0,1-.26-.38.55.55,0,0,1,.1-.47,4.32,4.32,0,0,1,1.6-1.31,6.55,6.55,0,0,1,2.29-.66,8.09,8.09,0,0,1,2.62.14A7.41,7.41,0,0,1,378.48,98.41Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.58,112.1a.71.71,0,0,1,.32.48.73.73,0,0,1-.11.56l-1.37,2a.71.71,0,0,1-.48.32.74.74,0,0,1-.56-.11l-2-1.34a.7.7,0,0,1-.31-.48.74.74,0,0,1,.11-.56l1.37-2a.76.76,0,0,1,1-.2Zm7.9-13.69a9.16,9.16,0,0,1,1.9,1.72,6.85,6.85,0,0,1,1.22,2.11,5.35,5.35,0,0,1,.3,2.31,4.82,4.82,0,0,1-.86,2.32,5.11,5.11,0,0,1-1.36,1.41,6.1,6.1,0,0,1-1.56.72,9.45,9.45,0,0,1-1.65.33l-1.57.17a7.54,7.54,0,0,0-1.4.29,2.3,2.3,0,0,0-1.06.65,1,1,0,0,1-.5.3.62.62,0,0,1-.54-.1l-1.75-1.18a.74.74,0,0,1-.32-.48.62.62,0,0,1,.12-.56,5.21,5.21,0,0,1,1.44-1.32,6.92,6.92,0,0,1,1.63-.67,9.94,9.94,0,0,1,1.67-.3c.56,0,1.08-.1,1.57-.16a6.41,6.41,0,0,0,1.3-.29,1.83,1.83,0,0,0,.9-.69,2.09,2.09,0,0,0,.23-1.93,3.8,3.8,0,0,0-1.57-1.89,3.67,3.67,0,0,0-4.2,0,1.55,1.55,0,0,1-.49.22.78.78,0,0,1-.52-.16L369.55,100a.57.57,0,0,1-.26-.38.55.55,0,0,1,.1-.47,4.32,4.32,0,0,1,1.6-1.31,6.55,6.55,0,0,1,2.29-.66,8.09,8.09,0,0,1,2.62.14A7.41,7.41,0,0,1,378.48,98.41Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.1,383c-.22,2.38,1.33,8.58,1.33,8.58s1.32,2,5.08,2.92l.26-9Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "294.51 394.45 301.93 390.7 302.75 383.49 294.66 389.26 294.51 394.45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M300.15,372.61,300,371.1c1.14.36,4.13,8.79,8.18,14.17,3.7,4.91,9.86,7,12.07,9.06,2.95,2.73-1.25,7.48-9.24,7-4-.24-10.15-1.8-12.12-4.15s-3.24-7-4.82-8.74-5-3.43-5.95-5.5c-.54-1.14-.34-3.78,0-6,.3-2.07.63-4.34,1.34-4.23,0,.25.17,1.27.17,1.27.24,1,1.57,2.06,5.72,1.61C297.19,375.37,300.48,374.66,300.15,372.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,336.9c-1.27,1.75-3.51,14-3.51,14s2.93,4.28,4.62,5.58l5.43-11.52Z",
    style: {
      fill: "#263238"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.42 356.43 229.38 354.14 233.08 346.47 222.71 349.36 219.42 356.43"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,329.13c-.57-.43-1.39.69-3.38,2.47-1.4,1.25-4.42,2.43-4.42,6,0,2.57,1.71,5.74,3.35,8.4s1.88,5.05,1.87,8.83c0,4.57-.84,7.37,4.78,11.44,4.5,3.25,13.64,3.85,15.65,2,3.44-3.22-4.59-7.64-5.9-14.23-1.8-9.09-2-10.61-1.75-17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,217.4c-4.38,2.37-17.68,3-36.34-1l2.21,54S263.19,282,258.16,288.33s-29.22,37.08-29.22,37.08h0l-3.34,3.87c-2.07,2.4-1,5.64,1.4,7.71,2.31,1.9,5.32,3.24,7.57,1.28l2.76-2.4s54.06-41.67,56-44.33,6.49-9.26,11.4-23.19C311.07,250.48,312.13,237.54,313.67,217.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,217.4c-11.81,5.42-35.55,3.57-35.55,3.57l1.09,49.35a103.9,103.9,0,0,0-16.68,12.61c-7.08,6.82-17.88,21-17.88,21,3.7,10.41,14.24,15.27,14.24,15.27s22.17-15.53,34.57-24.32c6.49-4.59,11.37-7.15,13.32-14.62a145.09,145.09,0,0,0,3.54-17.39c1.06-6.45,1.57-13.79,2.19-19.22A171.8,171.8,0,0,0,313.66,217.4Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,217.4c-11.81,5.42-35.55,3.57-35.55,3.57l1.09,49.35a103.9,103.9,0,0,0-16.68,12.61c-7.08,6.82-17.88,21-17.88,21,3.7,10.41,14.24,15.27,14.24,15.27s22.17-15.53,34.57-24.32c6.49-4.59,11.37-7.15,13.32-14.62a145.09,145.09,0,0,0,3.54-17.39c1.06-6.45,1.57-13.79,2.19-19.22A171.8,171.8,0,0,0,313.66,217.4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.94,281.43l-1.88-27.28-7-6.51-6,16.05.15,6.63a111.22,111.22,0,0,0-11.15,7.79l1,2.41,5.69,13.75s-2,9.38-1.16,14.56c6.55-4.6,14-9.85,19.59-13.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,373.8l0-1.12c-.86-10.09.53-65.57.47-80.54-.07-16.21-3-55.48-3-55.48s9.58-12.51,15.75-19.26c-5.83,6.67-35.23,3.29-37-9.55-2.41,5.06-11,10.28-11.71,26.91-1,21.19,14,58.66,14,58.66-.57,2.83-3.14,14.69-1.63,25.64,2.38,17.28,10.92,47.83,11.82,52l.55,3.55C291.65,376.93,299.18,376.58,300.53,373.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21,262.49l-.86-22.13s8.91-2.32,12.52-9.81a71,71,0,0,0,.8-13.15s-7.79,3.61-18.74.94a41,41,0,0,1-18.28-10.49s-2.1,2.07-6.41,8.5c-2.06,3.07-5.54,11-5.84,17.19-.69,14.13,3.82,29.21,3.82,29.21,2.3,11.06,9.28,31.19,9.28,31.19s-2.66,14.66-1.32,25.17,5.59,22.39,5.59,22.39,11.85,4,19.64-.64c0,0,.37-36.55.51-50.81S301.21,262.49,301.21,262.49Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.21,262.49l-.86-22.13s8.91-2.32,12.52-9.81a71,71,0,0,0,.8-13.15s-7.79,3.61-18.74.94a41,41,0,0,1-18.28-10.49s-2.1,2.07-6.41,8.5c-2.06,3.07-5.54,11-5.84,17.19-.69,14.13,3.82,29.21,3.82,29.21,2.3,11.06,9.28,31.19,9.28,31.19s-2.66,14.66-1.32,25.17,5.59,22.39,5.59,22.39,11.85,4,19.64-.64c0,0,.37-36.55.51-50.81S301.21,262.49,301.21,262.49Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.37,169.75a9,9,0,0,0,.54-11.23c-4.11-6.43-13.81-3.93-13.81-3.93l-2.59-4.17h0a7.58,7.58,0,0,1,3-.18,15.2,15.2,0,0,0,5.36-.76,8.14,8.14,0,0,0,4.55-3.25,4.29,4.29,0,0,0-.48-5.25,6.78,6.78,0,0,0,6.78-7.58,2.85,2.85,0,0,0-.62-1.6,4.1,4.1,0,0,0-1.82-.93,13.57,13.57,0,0,1-4.89-3c-2.77-2.65-3.94-5.76-7.77-8.25a19.68,19.68,0,0,0-10.92-3.24c-4.39,0-8.35,1.26-11.32,4.89-4.9,0-11.28,2.91-15.64,15-4.29,11.9-2.73,25.8,5.38,38.23,5.35,8.2,26.68,21.82,41.93,16.45S347.89,170.13,341.37,169.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.93,166.53c11.84,2.2,12.52,8.11,13.12,13.28,1.55,13.47-1.12,35.72-2.05,40.62,0,0-15.92-4.86-15.74-5.65S315.93,166.53,315.93,166.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.12,212.62s5.36-1.25,9.41,0c0,0-3.33-3.46-10.94-1.21Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76,216.44a80.52,80.52,0,0,0,4-13.29c7.91-4.07,9.64-10.14,8-15.83-3.4-11.71-6.71-17.41-9.75-20.79-2.36-1.67-10.76-4-10.76-4-1.5-.24-15.09-1.95-19.24-2.29a15,15,0,0,0-4.92,6.74c-.8,2.48-2.2,4.59-2.2,13.07l1.58,15.16s.42,4.54-1.17,7.18-8.07,7.47-11.06,14c0,0,.36,9.94,18.64,14.09,14.87,3.38,25.9-2,25.9-2A74.48,74.48,0,0,0,314.76,216.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,192.9a3.13,3.13,0,0,0-2-1.16c-1.72-.21-3.35.69-4.94,1.4-2.94,1.31-6.32,2-9.39,1.05-3.32-1.07-6-4-9.45-4.3-3.29-.26-6.23,2-8.65,4.21-3.58,3.33-6.9,7-11,9.69a54.12,54.12,0,0,1-5.46,3.07h0l-.8.84-.16.17c-.61.65-1.24,1.34-1.85,2.06l-.23.28-.66.8-.32.41-.55.73-.33.46-.51.76-.3.47c-.18.28-.34.56-.51.85l-.24.42c-.23.43-.46.87-.66,1.32a7.49,7.49,0,0,0,.47,2,12.74,12.74,0,0,0,1.57,2.92c.27.37.56.74.89,1.12,2.51,2.87,7.14,6.09,15.7,8a44.36,44.36,0,0,0,10.33,1.11c1.17,0,2.29-.07,3.36-.17s2.08-.22,3-.37c1.26-.2,2.42-.44,3.46-.69a30.46,30.46,0,0,0,5.73-1.92,69,69,0,0,0,.88-8.2c0-.59.06-1.2.08-1.84s0-1.31,0-2c1-2.83,1.92-5.4,2.6-7.64.17-.56.33-1.1.47-1.62a35.66,35.66,0,0,0,.93-4C324.1,200.4,326.62,196.74,327.18,192.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,132.56c.87,1.95,2.23,5.07-.85,17.31-2.61,10.37-6.57,12.18-8.44,12.53s-5-.83-7.24-1.69l-3.66,6.5c.33,2.8,1.29,8.44-.56,12-5.38-4.1-10.88-9.06-14.65-16.82l5.9-12.91s-3.42,1.64-5.25-2.28c-1.69-3.61-1.06-6.62,1.45-8.23a4.13,4.13,0,0,1,6.32,2.94c.54,3.09,3.54,3.32,4.37-1.27.25-1.4,1.43-9,6.84-10.69C323,138,331.14,136.87,332.38,132.56Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,143.14a1.41,1.41,0,1,1-1.14-1.69A1.44,1.44,0,0,1,318.4,143.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,154.14a1.36,1.36,0,0,1-1.56,1.14,1.4,1.4,0,1,1,1.56-1.14Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28,141.22l-2.23-2.45a1.59,1.59,0,0,1,2.3,0A1.74,1.74,0,0,1,330.28,141.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.94,137.31l-3.05,1.28a1.59,1.59,0,0,1,.83-2.16A1.73,1.73,0,0,1,317.94,137.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.89,145.09a1.41,1.41,0,1,1-2.78-.49,1.41,1.41,0,1,1,2.78.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.45 142.32 321.79 151.61 326.74 150.56 322.45 142.32",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.85,160.71c-3.25-1.2-10.56-5.15-11-8.12a7.29,7.29,0,0,0,1.62,4c1.66,2.23,8.17,6.24,8.17,6.24Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.78,165.43c-.35-1.11-1.78-1.22-1.78-1.22a3,3,0,0,0-.51-2.54,2.7,2.7,0,0,0-1.68-.52c.36-.79-.11-2.59-1.09-2.81a9.22,9.22,0,0,0-2.79.13,9.24,9.24,0,0,0-2.44,2.4L311,158a32.19,32.19,0,0,0,3.92-1.29c1.5-.76,1.43-2.4.85-2.49a23.66,23.66,0,0,0-3.91.4c-1.64.27-3.71.26-4.27,1.28s-1.18,2.24-2.33,4.58-1.47,3.05-1.32,4.39.13,4,.54,7.33-.25,4.11-1.72,6c-1,1.27-7.18,7.4-13.7,13.36l.89-12.95s2.12-13.32-2.93-18.3c-6.8-1.1-10.1,2-11.61,5.65-2.65,6.46-1.87,24.87-1.36,34.56s4.32,13.36,7.24,14,10.92-2.73,16.16-9.62c4.12-4.73,12.94-20.31,14.23-22.48a22.55,22.55,0,0,1,3.43-4.61c1-1,1.8-5,1.8-7.39.22.75,1,1.35,1.63.88C318.67,170.07,319.88,166.24,319.78,165.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.73,178.17a12.13,12.13,0,0,0,1.37-2,5.16,5.16,0,0,0,.43-2.39c0-.82-.14-1.64-.23-2.45s-.16-1.64-.22-2.46l-.14-2.46-.08-1.23a6.48,6.48,0,0,1-.05-1.25,7.78,7.78,0,0,1,.8-2.35c.34-.75.71-1.48,1.09-2.21l1.11-2.21.56-1.1a1.67,1.67,0,0,1,.91-.88,9.32,9.32,0,0,1,2.43-.51c.82-.09,1.62-.25,2.44-.35s1.63-.2,2.47-.22a.55.55,0,0,1,.37.12.75.75,0,0,1,.2.31,1.38,1.38,0,0,1,0,.67,2.06,2.06,0,0,1-.59,1.14,5.9,5.9,0,0,1-2.25,1.1c-.79.26-1.58.49-2.37.71l.09-.07-1.49,2.89-.23-.14a15.71,15.71,0,0,1,1.15-1.3q.3-.31.63-.6a3.27,3.27,0,0,1,.72-.53h0a11.22,11.22,0,0,1,1.53-.19,3.56,3.56,0,0,1,1.57.16,2.12,2.12,0,0,1,.9,1.3,2.51,2.51,0,0,1,0,1.58l-.11-.16a3.67,3.67,0,0,1,1.14.18,1.54,1.54,0,0,1,.53.29,2.35,2.35,0,0,1,.36.47,3.14,3.14,0,0,1,.26,2.25l-.09-.13a2.81,2.81,0,0,1,1.12.38,1.69,1.69,0,0,1,.74.92h0a6.62,6.62,0,0,1-.22,1.5l-.37,1.45c-.24,1-.53,1.92-.7,2.88v0l0,0a1,1,0,0,1-1.11,0,1.62,1.62,0,0,1-.64-.92l.15,0a19,19,0,0,1-.37,3.36,15.19,15.19,0,0,1-1,3.23,4.59,4.59,0,0,1-1,1.34c-.38.42-.75.84-1.09,1.28a26.19,26.19,0,0,0-1.88,2.79,27.26,27.26,0,0,1,1.84-2.82q.51-.66,1.08-1.29a4.5,4.5,0,0,0,1-1.34,14.84,14.84,0,0,0,.92-3.22,19.6,19.6,0,0,0,.35-3.33v-.53l.15.51a1.52,1.52,0,0,0,.58.82.75.75,0,0,0,.92,0l0,.06c.18-1,.46-1.94.7-2.91l.35-1.44a6.11,6.11,0,0,0,.21-1.44v0a1.93,1.93,0,0,0-1.7-1.15h-.12l0-.12a3,3,0,0,0-.25-2.09,1.29,1.29,0,0,0-.77-.66,3.51,3.51,0,0,0-1.07-.16h-.16l.06-.16a2.3,2.3,0,0,0,0-1.42,1.86,1.86,0,0,0-.79-1.15,3.46,3.46,0,0,0-1.45-.13,12.38,12.38,0,0,0-1.49.19h0a4.61,4.61,0,0,0-.65.49c-.21.19-.42.39-.61.59-.4.41-.77.84-1.13,1.29l-.82,1,.59-1.16,1.49-2.9,0-.06h.06c.79-.22,1.58-.44,2.35-.7a5.61,5.61,0,0,0,2.16-1,2,2,0,0,0,.53-1c.06-.35,0-.85-.36-.81a20.23,20.23,0,0,0-2.44.2c-.81.1-1.62.25-2.44.34a9,9,0,0,0-2.38.48,1.51,1.51,0,0,0-.82.79l-.56,1.1-1.12,2.19c-.37.73-.75,1.46-1.1,2.21a7.4,7.4,0,0,0-.78,2.29,5.47,5.47,0,0,0,0,1.21l.07,1.24.12,2.46c.05.82.11,1.64.19,2.46s.19,1.63.2,2.46a5.21,5.21,0,0,1-.47,2.4A11.82,11.82,0,0,1,302.73,178.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.85,161.27a2.37,2.37,0,0,0,.08-.87c-.82.22-1.88.33-2.56.57a2.32,2.32,0,0,0-1.27,1.14C312.45,161.74,313.45,161.26,315.85,161.27Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.11,164.93a5.1,5.1,0,0,1,2.88-.62,5.65,5.65,0,0,0,.09-.83C315.74,163.82,315.11,164.93,315.11,164.93Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.78,171a14.07,14.07,0,0,0-.08-3.17c-.11-.63-.15-1,.56-.89s1.69-.76,1.5-.17c-.1.32-1.36.85-1.44,1.3A15.11,15.11,0,0,1,316.78,171Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,191.53c-1.8,1.49-7.9,6.15-8.75,10.9,0,0-.85-3.56,2.65-7.52a72.88,72.88,0,0,1,6.3-6.37Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Arm--inject-121",
    d: "M327,220.43c-.61,3.55-1.74,4.85-5.36,6.44-5.9,2.59-29.53,9.28-36.51,9.33a35.3,35.3,0,0,1-11.68-1.76,3.16,3.16,0,0,1-1.72-1.08,4.14,4.14,0,0,0-1-1.2,14.38,14.38,0,0,0-1.56-.81,2.89,2.89,0,0,1-1.27-1.73,2.94,2.94,0,0,0-.43-1.33,6.68,6.68,0,0,1-.8-1,3.05,3.05,0,0,1-.39-1.57,2.49,2.49,0,0,0-.07-.82,1.94,1.94,0,0,0-.46-.64,8.07,8.07,0,0,1-.58-.73,1.35,1.35,0,0,1-.33-.74,1.38,1.38,0,0,1,.26-.61c.82-1.29,2.66-1,4-.86,1.59.18,3.15.49,4.74.68a34.56,34.56,0,0,0,6.67.15v-4.11A12.73,12.73,0,0,1,285,220c2.6,1.6,4.17,3.76,9,2.48s16.34-7.82,22.12-9.84S327.35,218.33,327,220.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-121"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.88 425.12 280.49 403.14 280.49 96.26 138.88 118.29 138.88 425.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.18 93.77 280.49 96.26 138.88 118.29 146.37 113.96 276.18 93.77",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.5 277.17 254.6 261.77 254.6 386.5 155.5 401.89 155.5 277.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.5 277.17 254.6 261.77 254.6 386.5 155.5 401.89 155.5 277.17",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 283.54 247.17 270.44 247.17 380.12 162.94 393.22 162.94 283.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.5 401.89 162.94 393.22 247.17 380.12 254.6 386.5 155.5 401.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.5 277.17 162.94 283.54 162.94 393.22 155.5 401.89 155.5 277.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.17 270.44 254.6 261.77 254.6 386.5 247.17 380.12 247.17 270.44",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.8 126.13 254.6 119.47 254.6 244.2 211.81 250.85 211.8 126.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.8 126.13 254.6 119.47 254.6 244.2 211.81 250.85 211.8 126.13",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.24 132.5 247.17 128.15 247.17 237.83 219.24 242.18 219.24 132.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.81 250.85 219.24 242.18 247.17 237.83 254.6 244.2 211.81 250.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.8 126.13 219.24 132.5 219.24 242.18 211.81 250.85 211.8 126.13",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.17 128.15 254.6 119.47 254.6 244.2 247.17 237.83 247.17 128.15",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.57 134.84 198.37 128.18 198.37 252.91 155.57 259.56 155.57 134.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.57 134.84 198.37 128.18 198.37 252.91 155.57 259.56 155.57 134.84",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163 141.21 190.93 136.85 190.94 246.54 163 250.89 163 141.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.57 259.56 163 250.89 190.94 246.54 198.37 252.91 155.57 259.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.57 134.84 163 141.21 163 250.89 155.57 259.56 155.57 134.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.93 136.85 198.37 128.18 198.37 252.91 190.94 246.54 190.93 136.85",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Latch--inject-121"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "261.41 239.06 263.34 241.01 263.34 273.05 261.41 271.11 261.41 239.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.34 241.01 273.75 239.45 273.75 271.5 263.34 273.05 263.34 241.01",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.75 248.27 263.34 249.79 263.34 256.06 273.75 254.55 273.75 248.27",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.75 239.45 271.82 237.51 261.41 239.06 263.34 241.01 273.75 239.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.33,247.08l4.78,4.8,1.91-2.5-4.78-4.79h0a1.09,1.09,0,0,0-.95-.32,1.75,1.75,0,0,0-1.35,1.76A1.5,1.5,0,0,0,267.33,247.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.34 249.85 270.93 250.69 270.93 248.41 272.78 248.14 271.04 246.39 263.34 247.56 263.34 249.85",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.71 252.6 247.71 257.6 274.83 253.54 274.83 248.54 247.71 252.6",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.71 252.6 245.98 250.85 245.98 255.86 247.71 257.6 247.71 252.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.83 248.54 273.09 246.79 245.98 250.85 247.71 252.6 274.83 248.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.79,261a2.3,2.3,0,0,1,1.76-2.29,1.61,1.61,0,0,1,1.75,1.77,2.44,2.44,0,0,1-1.06,2v3.27a.78.78,0,0,1-.59.78l-.21,0a.54.54,0,0,1-.59-.6v-3.27A1.72,1.72,0,0,1,266.79,261Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.64,453.82c8.51-8.78,13.51-44.54,5.21-51.51H86.59c-8.3,7-3.31,42.71,5.2,51.5l.24.25.29.29c.24.23.5.46.77.69a1.56,1.56,0,0,1,.2.16c.21.16.42.33.65.49a10.82,10.82,0,0,0,1.1.71c7,4.09,18.36,4.09,25.36,0h0a9.54,9.54,0,0,0,1.11-.72c.21-.14.4-.3.6-.45l.25-.2c.26-.22.51-.44.74-.67l.34-.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.26,399.5c-9.64,5.63-9.64,14.76,0,20.39s25.27,5.63,34.92,0,9.64-14.76,0-20.39S99.9,393.87,90.26,399.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.26,399.5c-9.64,5.63-9.64,14.76,0,20.39s25.27,5.63,34.92,0,9.64-14.76,0-20.39S99.9,393.87,90.26,399.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,402.21c-7.08,4.13-7.08,10.84,0,15s18.56,4.14,25.64,0,7.08-10.84,0-15S102,398.08,94.9,402.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54,409.32c-7.08-4.14-18.56-4.14-25.64,0a11.62,11.62,0,0,0-4.24,3.93,11.8,11.8,0,0,0,4.24,3.93c7.08,4.14,18.56,4.14,25.64,0a11.8,11.8,0,0,0,4.24-3.93A11.62,11.62,0,0,0,120.54,409.32Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.29,332.94l16.9,11.56-16-6.05a29.12,29.12,0,0,0,3.16,12.28s10.55,5.12,16.29,10.52L90.6,356.83a15.64,15.64,0,0,0,.44,7.35c.09.32.19.66.3,1,.74,2.25,1.8,6.5,3.6,11.54,0,0,0,0,0,0a73,73,0,0,0,5.81,12.7,51.11,51.11,0,0,0,3.86,5.71c.08.12.17.23.26.34q3.91-2.61,8.14-5.11c1.63-4.14,3.42-14.22,3.74-22.4C118,336.66,93.25,320.52,74,315.88,74,315.88,81,323.56,84.29,332.94Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.29,332.94l16.9,11.56-16-6.05a29.12,29.12,0,0,0,3.16,12.28s10.55,5.12,16.29,10.52L90.6,356.83a15.64,15.64,0,0,0,.44,7.35c.09.32.19.66.3,1,.74,2.25,1.8,6.5,3.6,11.54,0,0,0,0,0,0a73,73,0,0,0,5.81,12.7,51.11,51.11,0,0,0,3.86,5.71c.08.12.17.23.26.34q3.91-2.61,8.14-5.11c1.63-4.14,3.42-14.22,3.74-22.4C118,336.66,93.25,320.52,74,315.88,74,315.88,81,323.56,84.29,332.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.77,333.3a23.25,23.25,0,0,1,4.39,5.29,46.16,46.16,0,0,1,3.09,6.17A62.81,62.81,0,0,1,109,358a58.2,58.2,0,0,1-1.49,27.2h0a.46.46,0,0,0,.3.57.45.45,0,0,0,.56-.3h0a58.91,58.91,0,0,0,1.07-27.55,63.55,63.55,0,0,0-4-13.25,47.07,47.07,0,0,0-3.2-6.14A23.68,23.68,0,0,0,97.77,333.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,348.93l0,0c-.38.49-6.37,5.71-15.55,21.32L122.68,375l15.14,1.36-7,12.16L115,392.4,127.55,394s-3,12.34-11.74,17.77c-4.84,3-7.23,3.52-8.77,2.17-1.08-.95-1.54-6.79-2.61-12s-1.47-13.68,3.06-24.11a32,32,0,0,1,4.84-7.73C123.66,356.42,145.78,349.2,156.85,348.93Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,348.93l0,0c-.38.49-6.37,5.71-15.55,21.32L122.68,375l15.14,1.36-7,12.16L115,392.4,127.55,394s-3,12.34-11.74,17.77c-4.84,3-7.23,3.52-8.77,2.17-1.08-.95-1.54-6.79-2.61-12s-1.47-13.68,3.06-24.11a32,32,0,0,1,4.84-7.73C123.66,356.42,145.78,349.2,156.85,348.93Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,383.1h0v0a49.15,49.15,0,0,0-3.21,13.6h0A145.1,145.1,0,0,0,108,414.4a2.68,2.68,0,0,1-.92-.51c-1.08-.95-1.54-6.79-2.61-12s-1.47-13.68,3.06-24.11a32,32,0,0,1,4.84-7.73c11.33-13.65,33.45-20.87,44.52-21.14-16.88,3.43-34.7,15.44-43.21,28.93A35,35,0,0,0,111,383.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,354.91c-8.27,4-16,9.39-22,16.5a43.89,43.89,0,0,0-7.3,11.81,42,42,0,0,0-3,13.5s0,0,0,0a.07.07,0,0,0,.05,0,54,54,0,0,1,3.76-13.16,50.77,50.77,0,0,1,7-11.7,58.53,58.53,0,0,1,9.88-9.51A76.87,76.87,0,0,1,140.08,355a0,0,0,0,0,0-.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.23,360.75h0a34.32,34.32,0,0,1,4.1,0,65.9,65.9,0,0,1,15.85,2.94c1.91.6,3.83,1.28,5.72,2.06.95.39,1.89.8,2.81,1.24a45.36,45.36,0,0,1,12.49,8.4,28.51,28.51,0,0,1,4.45,5.57c.16.26.33.52.48.79h0c.38.7.74,1.38,1.07,2.06a39.21,39.21,0,0,1,4.6,19.05c.09,4.68-1.21,10.1-2.06,11a2.44,2.44,0,0,1-.39.33c-1.29.92-3.43.54-7.5-1.45-8.17-4-11.9-15-11.9-15l10.9-2.48-14.29-2-6.24-8.64L88.79,382,74.31,380.6a212.56,212.56,0,0,0-16.06-19.83l0,0Z",
    style: {
      fill: "#3C8DBC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.33,360.71a65.9,65.9,0,0,1,15.85,2.94c1.91.6,3.83,1.28,5.72,2.06.95.39,1.89.8,2.81,1.24a45.36,45.36,0,0,1,12.49,8.4,28.51,28.51,0,0,1,4.45,5.57c.16.26.33.52.48.79h0c.38.7.74,1.38,1.07,2.06a39.21,39.21,0,0,1,4.6,19.05c.09,4.68-1.21,10.1-2.06,11a2.44,2.44,0,0,1-.39.33,2.67,2.67,0,0,1-.86.37c.58-7.29-4-25.43-9.8-32.68-6-7.53-20-18.18-38.45-21.09v0A36.09,36.09,0,0,1,62.33,360.71Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,414.54a62.12,62.12,0,0,0-1.93-15.94,51.71,51.71,0,0,0-6.14-14.87,35.69,35.69,0,0,0-5.2-6.22,51.21,51.21,0,0,0-6.21-5.18,60,60,0,0,0-14.23-7.5,0,0,0,0,0,0,.09,77.68,77.68,0,0,1,13.74,8.14,63.51,63.51,0,0,1,6.12,5.09,35.26,35.26,0,0,1,5.22,6,51.5,51.5,0,0,1,6.31,14.59,62.2,62.2,0,0,1,2.27,15.82,0,0,0,0,0,.09,0Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cat--inject-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cat--inject-121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.88,337.54c-1.16,3.67-7.78,13-10,15.55s-2.56,13.54-2.54,15.83,1.55,4.46,2.52,5.93-.71,4-4.24,2.84-4.6-4.73-5.12-7.12-1.69-16.09-.24-24.6C375.26,346,382.46,336.83,394.88,337.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.69,303.15c-5.59.12-13.31-4.33-16-12s-1.08-19,1.81-25.44c1.65-3.66,1.14-6-.26-6.69-2.06-1-4.13.13-5.66,3.37-1.94,4.16-5.84,19.68-2.33,29.13s9.9,14.53,13.66,16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.93,324.69c.34,7.52,3.94,20.83,6,24.08,2.16,3.43,3.84,4.41,7.33,4.51s4-2.93-.43-5.64c-.84-1.19-1.15-7-.67-13.05S338.93,324.69,338.93,324.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.85,309.68c0,4,.72,14.7-1.8,21.62-2.4,6.59-6.77,12.63-16.58,14.16s-18.46-.57-24.12-3.84-11.19-9.86-15.18-10.61a19.14,19.14,0,0,1-9.74,4.85c-6.49,1.33-9.76-.31-9.76-.31s-1.9,5.3-2,8,0,5.27,2.06,6.67,3.07,2.11,2.85,3.59c0,0,0,1.64-4.23,1.52s-4.34-.8-5.61-4.6-2.89-13.66-3.13-16.95,3.78-3.72,5.78-6.43a30.72,30.72,0,0,0,5-9.76c1.36-4.33,4.53-11.05,11.4-13.27s13.83-1.62,23.46,2.59,14.44,6,19.17,3.39c6.42-3.58,5.77-9.22,5.77-9.22C390.14,300.11,398.05,296.45,399.85,309.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,345.92l-.55-2.35-4.59-2.28-1.41.91a18.31,18.31,0,0,1,2.1,3.68A41.07,41.07,0,0,0,376.78,345.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,342.2c2.76,1.84,4.95,5.92,8.84,8.34a20.21,20.21,0,0,0,7.2,2.86,22.22,22.22,0,0,1,2.46,5.91c.88,3.46,1.89,7.76,4.83,9.67s7.61.64,5.19-2.75c-1.72-2.41-2.53-5.48-3.35-8.57-1.09-4.08-.15-6-2.21-8.71a27.32,27.32,0,0,1-5.15-9.9S374.39,336.11,370.23,342.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,331.53a11.33,11.33,0,0,0,1.23-6.95,15,15,0,0,1-2.77,6.43A6.51,6.51,0,0,1,343.71,331.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,306.08c8.28,7.92-1.94,13-1.68,23.23.08,3.38,1.62,7,5,13.41a21.56,21.56,0,0,0,9.11-11.29c1.9-5.22,1.88-13.64,1.49-17.73a22.12,22.12,0,0,0-3-9.16S377.7,298.16,386,306.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.83,310.08a18.11,18.11,0,0,0,10.77,1.45,10.43,10.43,0,0,0,8.33-7l-14.15-.33A10.7,10.7,0,0,1,377.83,310.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.7,285.51c2.18-2.56,7.83-4.58,10.81-2.05,1.68,1.43-2.8,9.19-2.8,9.19S392.92,289.54,390.7,285.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,288.19c2.76,2.3,5.69,4.46,5.69,4.46s4.48-7.76,2.8-9.19C400.34,282.75,396.49,283.38,393,288.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.55,290.76a3.58,3.58,0,0,1,.87-.84c.25-.49.54-1.07.83-1.69a7.53,7.53,0,0,0-2.84-1.05,2.8,2.8,0,0,1,1-1.7,3.27,3.27,0,0,0-3.89,2.09,5.74,5.74,0,0,0,1.09,2.09c.62.42,1.19.77,1.65,1.06A3,3,0,0,0,398.55,290.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,288.28a3.26,3.26,0,0,1,3.2-2,2.69,2.69,0,0,0-.66,1.81s3.2-.17,4,1.47a3.49,3.49,0,0,0-3,1.76C395.79,292.39,395,288.28,395,288.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.51,283a13,13,0,0,1,3.62,8.94l2.36-1.7s.06-4.16-1.7-5.63A8.11,8.11,0,0,0,372.51,283Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.33,285.72c-1.13-2.27-7-5.22-10.82-2.68,0,0,5,1.61,5.24,6.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.85,309.77c-.32-4.76.9-11.11.15-14.73-.88-4.22-3.46-9.6-11.67-10.05s-12.21,3.91-13.64,9.37c-.85,2.72-2,3.9-1.65,6.91a8.84,8.84,0,0,0,6.91,7.88c3.46,1,12.65,1.28,17-4.61l2.92,5.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69,289.13s-.13-.82-1.53-1.69a4.55,4.55,0,0,0-3.46-.41s1.88,1.54,2.09,2.79a4,4,0,0,0-2.17-.07s2.75,1.89,2.22,4.8C374.84,294.55,377.75,291.12,377.69,289.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.56,302.67h0a.38.38,0,0,1-.36-.38l.06-1.89a.38.38,0,0,1,.38-.36h0a.37.37,0,0,1,.36.38l-.06,1.89A.38.38,0,0,1,382.56,302.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.3,303.86a.35.35,0,0,1-.19-.06l-1.55-1.06-1.58,1a.37.37,0,0,1-.38-.63l1.78-1.08a.35.35,0,0,1,.4,0l1.74,1.19a.37.37,0,0,1,.1.51A.36.36,0,0,1,384.3,303.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.67,298.15c-1.9-.09-2.13.48-1.94,1.16a3.42,3.42,0,0,0,1.83,1.57c.45.07,2.17-.78,2.24-1.51S384.46,298.24,382.67,298.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.19,300l0,0a.32.32,0,0,1,.06-.45,5.86,5.86,0,0,1,6.65-.89.33.33,0,0,1-.3.59,5.27,5.27,0,0,0-6,.8A.3.3,0,0,1,389.19,300Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.74,301l-.06-.1a.35.35,0,0,1,.18-.43,5.48,5.48,0,0,1,4.49.26.33.33,0,0,1-.34.57,4.83,4.83,0,0,0-3.92-.24A.3.3,0,0,1,389.74,301Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.16,302.24a.24.24,0,0,1-.07-.18.34.34,0,0,1,.3-.36,6.28,6.28,0,0,1,5.29,2.46.32.32,0,0,1-.06.45.3.3,0,0,1-.44,0h0a5.67,5.67,0,0,0-4.76-2.23A.28.28,0,0,1,389.16,302.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,299.47l0,0a.33.33,0,0,0,0-.46,5.84,5.84,0,0,0-6.34-2.18.33.33,0,0,0,.18.63,5.27,5.27,0,0,1,5.7,2A.31.31,0,0,0,378,299.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.31,300.29a.27.27,0,0,0,.07-.08.34.34,0,0,0-.11-.45,5.47,5.47,0,0,0-4.5-.33.33.33,0,0,0-.15.43.33.33,0,0,0,.42.17,4.85,4.85,0,0,1,3.91.28A.29.29,0,0,0,377.31,300.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.78,301.63a.31.31,0,0,0,.09-.18.34.34,0,0,0-.26-.38,6.27,6.27,0,0,0-5.53,1.85.33.33,0,0,0,0,.46.29.29,0,0,0,.43,0h0a5.68,5.68,0,0,1,5-1.69A.27.27,0,0,0,377.78,301.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.5,295a1.25,1.25,0,1,1-1.21-1.29A1.25,1.25,0,0,1,390.5,295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.42,294.6a1.25,1.25,0,1,1-1.2-1.28A1.24,1.24,0,0,1,380.42,294.6Z",
    style: {
      fill: "#263238"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutImg);
export default __webpack_public_path__ + "static/media/logoutImg.c53c69a10132dca79c50646df8e71e72.svg";
export { ForwardRef as ReactComponent };